var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateDeploymentPlans = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM12 6C12 8.79987 10.0822 11.1518 7.48857 11.8139C7.49611 11.8749 7.5 11.937 7.5 12V19.5H22.5V11.811C19.9122 11.1449 18 8.79576 18 6C18 2.68629 20.6863 0 24 0C27.3137 0 30 2.68629 30 6C30 8.79576 28.0878 11.1449 25.5 11.811V19.5H40.5V12C40.5 11.937 40.5039 11.8749 40.5114 11.8139C37.9178 11.1518 36 8.79988 36 6C36 2.68629 38.6863 0 42 0C45.3137 0 48 2.68629 48 6C48 8.79988 46.0822 11.1518 43.4886 11.8139C43.4961 11.8749 43.5 11.937 43.5 12V21C43.5 21.8284 42.8284 22.5 42 22.5H25.5V32.5854C26.0277 32.3993 26.6386 32.5173 27.0607 32.9393C27.6464 33.5251 27.6464 34.4749 27.0607 35.0607L25.0607 37.0607C24.4749 37.6464 23.5251 37.6464 22.9393 37.0607L20.9393 35.0607C20.3536 34.4749 20.3536 33.5251 20.9393 32.9393C21.3614 32.5173 21.9723 32.3993 22.5 32.5854V22.5H6C5.17157 22.5 4.5 21.8284 4.5 21V12C4.5 11.937 4.50389 11.8749 4.51143 11.8139C1.91779 11.1518 0 8.79987 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM24 9C25.6569 9 27 7.65685 27 6C27 4.34315 25.6569 3 24 3C22.3431 3 21 4.34315 21 6C21 7.65685 22.3431 9 24 9ZM45 6C45 7.65685 43.6569 9 42 9C40.3431 9 39 7.65685 39 6C39 4.34315 40.3431 3 42 3C43.6569 3 45 4.34315 45 6Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateDeploymentPlans);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateDeploymentPlans.765620b1a737e1863f9c7830afa86fa7.svg";